import Cookies from "js-cookie";
import { logoutUser } from "./UserService";
import { toast, Bounce } from "react-toastify";

export const handleLogOut = async (navigate) => {
  try {
    const token = Cookies.get("access_token");

    if (!token) {
      toast.error("No token found. You are already logged out.", {
        position: "top-right",
        autoClose: 1200,
        theme: "dark",
        transition: Bounce,
      });
      return;
    }

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const logout = await logoutUser(config);
    console.log(logout);

    if (logout.message === "Logout successful") {
      toast.success("Logged out successfully!", {
        position: "top-right",
        autoClose: 1200,
        theme: "dark",
        transition: Bounce,
      });

      Cookies.remove("access_token");
      Cookies.remove("user");

      navigate("/login"); // Use the passed navigate function
    }
  } catch (error) {
    console.error("Error during logout:", error);

    toast.error("Logout failed. Please try again.", {
      position: "top-right",
      autoClose: 1200,
      theme: "dark",
      transition: Bounce,
    });
  }
};
